<div class="slider-container">
  <nz-slider #slider
    [class.gradient-rail]="isGradientSlider"
    [(ngModel)]="value"
    [nzMarks]="marks"
    [nzMin]="min" 
    [nzMax]="max" 
    [nzStep]="step"
    [nzIncluded]="false"
    [nzTipFormatter]="formatter"
    (ngModelChange)="onSliderValueChange($event)"
    [nzDisabled]="isDisabled"
  >
  </nz-slider>
  <div #recommendedValueBar class="recommended-value-bar" [hidden]="isRecommendedValueInvalid"></div>
</div>